<template>
  <transition name="modal">
    <div class="modal__mask" @click="clickMaskClose">
      <div class="modal__wrapper">
        <div
          :class="[
            'modal__container',
            noScroll ? 'modal__container_no-scroll' : ''
          ]"
          :style="slotStyle"
          @click.stop
        >
          <slot class="modal__container__slot" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AppModal",
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    minWidth: {
      type: String,
      default: ""
    },
    maxHeight: {
      type: String,
      default: "100%"
    },
    noScroll: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    isClickMaskClose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    slotStyle() {
      let result = {
        maxWidth: this.maxWidth,
        maxHeight: this.maxHeight
      };

      if (this.fullHeight) {
        result.height = "98%";
      }

      if (this.minWidth) {
        result.minWidth = this.minWidth;
      }

      return result;
    }
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    ok() {
      this.$emit("ok");
    },
    clickMaskClose() {
      if (this.isClickMaskClose) {
        this.close();
      }
    }
  },
  created() {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  },
  beforeDestroy() {
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  }
};
</script>

<style lang="scss" scoped>
.modal__mask {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: table;
  transition: opacity 0.9s ease;

  .modal__wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal__container {
    margin: 0px auto;
    overflow: auto;
    background-color: #f2f6fc;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    border-radius: 5px;
    transition: all 0.9s ease;
  }

  .modal__container__slot {
    height: 100%;
  }

  .modal__container_no-scroll {
    overflow: hidden;
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1.1);
}
</style>
